var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.27643 7.89515L16.5858 0.585786L18 2L9.27804 10.722L9.27679 10.7207L9.27517 10.7223L0.550392 1.99754L1.96461 0.583325L9.27643 7.89515Z"}));
}

Chevron.defaultProps = {"width":"18","height":"11","viewBox":"0 0 18 11","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
